/** @format */

import {
  Card,
  CardObject,
  SublessonResponse,
} from "../../../features/resources/types";
import { api } from "../api";

export type UserResourceCardBody = {
  Object: CardObject;
  PK: string;
  SK: string;
  Parent: string;
  UUID: string;
  Code: string;
  Locale: string;
  originalUUID?: string;
};

export type DeleteUserResourceCardParams = {
  code: string;
  locale: string;
  subLessonUuid: string;
  cardUuid: string;
  copy: number;
};

export type DeleteUserResourceCardResponse = {
  response: {
    $metadata: {
      httpStatusCode: number;
      requestId: string;
      attempts: number;
      totalRetryDelay: number;
    };
    ConsumedCapacity: {
      CapacityUnits: number;
      TableName: string;
    };
  };
  messages: string[];
  key: {
    PK: string;
    SK: string;
  };
};

export const userCardsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getUserResourceSubLessonCards: build.query<
      Card[],
      {
        resourceId: string;
        locale: string;
        copy: number;
        subLessonUuid: string;
      }
    >({
      query: ({ resourceId, locale, subLessonUuid, copy }) => {
        return {
          url: `user-resource/cards/${resourceId}/${locale}/${copy}/${subLessonUuid}`,
        };
      },
      transformResponse(res: SublessonResponse) {
        return res.cards;
      },
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ UUID }) => ({
                type: "Card" as const,
                id: UUID,
              })),
              { type: "Card", id: "LIST" },
            ]
          : [{ type: "Card", id: "LIST" }],
    }),

    saveUserResourceCard: build.mutation<
      { message: string },
      { body: UserResourceCardBody; code: string; locale: string; copy: number }
    >({
      query({ body, code, locale, copy }) {
        return {
          url: `user-resource/save-card/${code}/${locale}/${copy}`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: (res, err, args) => [
        { type: "Card", id: args.body.UUID },
      ],
    }),
    deleteUserResourceCard: build.mutation<
      string,
      DeleteUserResourceCardParams
    >({
      query({ code, locale, subLessonUuid, cardUuid, copy }) {
        return {
          url: `user-resource/delete-card/${code}/${locale}/${copy}/${subLessonUuid}/${cardUuid}`,
          method: "DELETE",
        };
      },
      transformResponse: (response: { message: string }) => response.message,
      invalidatesTags: [
        "SubLesson",
        "Card",
        "Resource", // TODO: REMOVE AT LATER DATE
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetUserResourceSubLessonCardsQuery,
  useSaveUserResourceCardMutation,
  useDeleteUserResourceCardMutation,
} = userCardsApi;
